<template>
  <popup ref="popup" :show.sync="openPop" :class="[isMobile ? 'h5':'pc',{'form-pre':formParams.isPre}]"
  @update:show="close" :title="title" :showClose="!formParams.isPre">
    <consult-form-for-h5 v-if="isMobile" @updateFormTitle="updateFormTitle"
    :formParams="formParams" :requestDomain="domain" @onFormSubmit="onFormSubmit"
    @skipForm="skipForm"
    source="popup"></consult-form-for-h5>
    <consult-form-for-pc v-else @updateFormTitle="updateFormTitle"
    :formParams="formParams" :requestDomain="domain"
    @onFormSubmit="onFormSubmit" source="popup" @skipForm="skipForm"></consult-form-for-pc>

  </popup>
</template>

<script>
import Popup from '@/components/Popup';
import ConsultFormForH5 from './ConsultFormForH5';
import ConsultFormForPc from './ConsultFormForPc';
import DOMAIN from '@/imsdk/domain';
import { IMSDK } from '@/imsdk/index';
import globalWin from '@/utils/globalWin';
const imsdk = IMSDK.create();
const domain = DOMAIN.getSDKDomain();

export default {
  components: {
    Popup,
    ConsultFormForH5,
    ConsultFormForPc,
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  inject: ['globalData', 'wpaDetail', 'to'],
  data() {
    return {
      openPop: false,
      title: '',
      formParams: {
        kfext: this?.globalData?.reception?.extuin, // B工号
        wpaId: this?.wpaDetail?.wpaId, // 根据wpaId获取询前表单配置，询前必填
        isPre: false, // 是否询前
        uk: '',
        channelID: imsdk?.config?.channelType, // 通路id
        custID: this?.to?.user_id, // C社交账号
        formID: this?.formId,
        kfuin: this?.wpaDetail?.kfuin,
      },
      domain: domain.api,
      isShowSubmited: true,
    };
  },
  methods: {
    show(params) {
      setTimeout(() => {
        this.openPop = true;
        const { formId = '', grayMsgSeq = '', uk = '', isPre = false } = params;
        // 跟表单关联的那条灰条消息的Seq
        this.connectionGrayMsgSeq = grayMsgSeq;
        // 后端透传的特征值
        this.formParams = {
          uk,
          isPre: !!Number(isPre),
          formId,
          kfext: this?.globalData?.reception?.extuin, // B工号
          wpaId: this?.wpaDetail?.wpaId, // 根据wpaId获取询前表单配置，询前必填
          channelID: imsdk?.config?.channelType, // 通路id
          custID: this?.to?.user_id, // C社交账号
          kfuin: this?.wpaDetail?.kfuin,
        };
      }, 400);
    },
    close() {
      this.openPop = false;
    },
    onFormSubmit(params = {}) {
      const textContent = this.getFormTextMsgContent(params.submitData);
      globalWin.sendTextMessage(textContent);
      // 处理下点击的那条灰条消息，隐藏填写按钮
      globalWin.splitGrayMsgContent(this.connectionGrayMsgSeq);
      this.close();
    },
    /**
     * 组装上屏文本消息内容
     * @returns
     */
    getFormTextMsgContent(submitData) {
      try {
        const formStr = submitData.reduce((text, item) => {
          let shownText = '';
          if (item.encrypted) {
            shownText = '****';
          } else {
            switch (item.type) {
              case 6:
              case 7: {
                const choosedItem = item.options.find(element =>  element.value === item.value);
                shownText = choosedItem ? choosedItem.text : '';
                break;
              }

              case 8: {
                const choosedArray = JSON.parse(item.value);
                shownText = Array.isArray(choosedArray) ? choosedArray.reduce((str, opt) => `${str}\n   ● ${opt}`, '') : '';
                break;
              }
              default:
                shownText = item.value;
                break;
            }
          }
          const itemStr = `- ${item.name}: ${shownText}\n`;
          return text + itemStr;
        }, '');
        return `我已提交表单“${this.title}”\n${formStr}`;
      } catch {
        return `我已提交表单${this.title}`;
      }
    },

    /**
     * 更新表单标题
     * @param {*} title
     */
    updateFormTitle(title) {
      this.title = title;
    },
    skipForm() {
      this.close();
    },
  },
};
</script>

<style lang="less" scoped>
    .pc.form-pre {
      :deep(.bottom-popup-inner){
        height: 540px !important;
        max-height: unset !important;
        min-height: unset !important;
      }
    }

    .h5.form-pre {
      :deep(.bottom-popup-inner){
        height: calc(100vh - 60px);
        max-height: unset !important;
        min-height: unset !important;
      }
    }
</style>

